import axios from './auth-v2-axios'
import { AuthCredential } from '@/types/credentials'

export function getCredential(path: string, credentialId: string) {
  return axios.get<AuthCredential>(
    `${path}/${credentialId}?redirect_path=/credential-authenticated`,
  )
}
